import { DateString } from '~/types/CommonTypes';

export enum RedemptionStatusEnum {
  REQUESTED = 1,
  UNDER_ANALYSIS = 2,
  IN_PROCESS = 3,
  PAID = 4,
  REFUSED = 5,
}

export enum RedemptionStatusDtoEnum {
  'Solicitado' = 1,
  'Em análise' = 2,
  'Em processamento' = 3,
  'Pago' = 4,
  'Recusado' = 5,
}

export class Redemption {
  redemptionId: string = '';
  status: string = '';
  amount: string = '';
  createdAt: Date | null = null;

  constructor(data: Partial<Redemption> = {}) {
    this.redemptionId = this.validateRedemptionId(data.redemptionId)
      ? data.redemptionId
      : '';
    this.status = this.validateStatus(data.status) ? data.status : '';
    this.amount = this.validateAmount(data.amount) ? data.amount : '';
    this.createdAt = this.validateCreatedAt(data.createdAt) ? data.createdAt : null;
  }

  private validateRedemptionId(redemptionId: unknown): redemptionId is string {
    const isValid: boolean =
      typeof redemptionId === 'string' &&
      redemptionId.startsWith('#') &&
      redemptionId !== '#undefined';
    if (!isValid) console.error('The provided redemptionId is not valid:', redemptionId);
    return isValid;
  }
  private validateCreatedAt(createdAt: unknown): createdAt is Date {
    const isValid: boolean = createdAt instanceof Date || createdAt === null;
    if (!isValid) console.error('The provided createdAt is not valid:', createdAt);
    return isValid;
  }

  private validateAmount(amount: unknown): amount is string {
    const usAmountRegex = RegExp(/((US?\$) (\d{0,3})((,\d{3})+)?(\.(\d{2})))/);
    const amountRegex = RegExp(/([A-Z]{1,2}\$) (\d{0,3})((\.\d{3})+)?(,(\d{2}))/);

    const isValid: boolean =
      typeof amount === 'string' &&
      (usAmountRegex.test(amount) || amountRegex.test(amount));
    if (!isValid)
      console.error(
        `The provided amount (${amount}) is not valid, it should be a string like "R$ 1.000,00" or "$ 1,000.00"`,
      );
    return isValid;
  }

  private validateStatus(status: unknown): status is string {
    const isValid: boolean =
      typeof status === 'string' && Object.values(RedemptionStatusEnum).includes(status);
    if (!isValid) console.error('The provided status is not valid:', status);
    return isValid;
  }
}

export class RedemptionDto {
  id: string = '';
  status: string = '';
  value: number = 0;
  createdAt: DateString = '' as DateString;

  constructor(data: Partial<RedemptionDto> = {}) {
    this.id = this.validateId(data.id) ? data.id : '';
    this.status = this.validateStatus(data.status) ? data.status : '';
    this.value = this.validateValue(data.value) ? data.value : 0;
    this.createdAt = this.validateCreatedAt(data.createdAt)
      ? data.createdAt
      : ('' as DateString);
  }

  private validateCreatedAt(createdAt: unknown): createdAt is DateString {
    const isValid: boolean =
      typeof createdAt === 'string' && !isNaN(Date.parse(createdAt));
    if (!isValid) console.error('The provided createdAt is not valid:', createdAt);
    return isValid;
  }
  private validateValue(value: unknown): value is number {
    const isValid: boolean = typeof value === 'number' && !isNaN(value);
    if (!isValid) console.error('The provided value is not valid:', value);
    return isValid;
  }
  private validateId(id: unknown): id is string {
    const isValid: boolean = typeof id === 'string' && !id.startsWith('#');
    if (!isValid) console.error('The provided id is not valid:', id);
    return isValid;
  }
  private validateStatus(status: unknown): status is string {
    const isValid: boolean =
      typeof status === 'string' &&
      Object.values(RedemptionStatusDtoEnum).includes(status);
    if (!isValid) console.error('The provided status is not valid:', status);
    return isValid;
  }
}

export class RedemptionListFilters {
  date: Date[] = [];
  status: number = 0;
  amount: string = '';
  redemptionId: string = '';
}

export class RedemptionListFiltersDto {
  StartDate?: string;
  EndDate?: string;
  Status?: string;
  Value?: number;
  ID?: string;

  constructor(data: Partial<RedemptionListFiltersDto> = {}) {
    this.StartDate = data.StartDate;
    this.EndDate = data.EndDate;
    this.Status = data.Status;
    this.Value = data.Value;
    this.ID = data.ID;
  }
}
